import React from 'react'
import Layout from './Layout';
import { PrayerWall } from '../../components/User/Prayer'

export const PrayerPage = () => <Layout><PrayerWall></PrayerWall></Layout> 
